<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-warning">
            <div class="card-icon">
              <i class="material-icons">map</i>
            </div>
            <h4 class="card-title ">Rute</h4>
          </div>
          <div class="card-body">
              <div class="row">
                  <div class="cal-activity">
                    <form [formGroup]="dateForm">
                      <mat-form-field class="mr-sm-24" fxFlex>
                        <input matInput [matDatepicker]="picker" placeholder="Na dan" autocomplete="off" name="date"
                          formControlName="date" (dateChange)="loadData()">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker [startAt]="date" #picker></mat-datepicker>
                      </mat-form-field>
                    </form>
                  </div>
                </div>
            <div class="table-responsive">
              <table class="table">
                <thead class="text-primary">
                  <tr>
                    <th>Tablice</th>
                    <th>Marka</th>
                    <th>Tip</th>
                    <th>Broj kartice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let vehicle of vehicles" [routerLink]="['/routes/',date.toJSON() ,vehicle.imei]"
                    routerLinkActive="router-link-active" class="pointer">
                    <td>{{vehicle.tag}}</td>
                    <td>{{vehicle.brand}}</td>
                    <td>{{vehicle.type}} </td>
                    <td>{{vehicle.cardNumber}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>